import { esimInfoENUM } from '../../../constants';
import fetchEsims from '../../../services/apollo/func/fetch/fetchEsims';
import { formatPascalCase } from '../../../utils';

export const formatCardLicenses = data => data.map(cardLicense => ({
  key: cardLicense.id,
  eID: cardLicense.id,
  status: (cardLicense?.status === esimInfoENUM.ACTIVE || cardLicense?.status === esimInfoENUM.INACTIVE) ? esimInfoENUM.UNBLOCKED : esimInfoENUM.BLOCKED,
  storage: (cardLicense?.license?.storage === -1 ? esimInfoENUM.UNLIMITED : cardLicense?.license?.storage) || '--',
  licenseType: cardLicense?.license?.licenseType ? formatPascalCase(cardLicense.license.licenseType) : '--',
  brand: cardLicense?.compatibleBrand ? (cardLicense.compatibleBrand) : '--',
  model: cardLicense?.compatibleModel ? (cardLicense.compatibleModel) : '--',
  dual: cardLicense?.license?.isAllowedDual ? esimInfoENUM.ALLOWED : esimInfoENUM.NOT_ALLOWED,
  createdBy: cardLicense?.createdBy ? `${cardLicense?.createdBy?.firstName} ${cardLicense?.createdBy?.lastName}` : '--',
}));

export const getCardLicenseStatusColumns = () => {
  const columns = [
    {
      title: 'eID',
      dataIndex: 'eID',
      key: 'eID',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
    },
    {
      title: 'Storage',
      dataIndex: 'storage',
      key: 'storage',
    },
    {
      title: 'License type',
      dataIndex: 'licenseType',
      key: 'licenseType',
    },
    {
      title: 'Brand',
      dataIndex: 'brand',
      key: 'brand',
    },
    {
      title: 'Model',
      dataIndex: 'model',
      key: 'model',
    },
    {
      title: 'Dual-eSIM',
      dataIndex: 'dual',
      key: 'dual',
    },
    {
      title: 'Created by',
      dataIndex: 'createdBy',
      key: 'createdBy',
    },
  ];
  return columns;
};

export const getCardLicenseStatusSearchBy = () => {
  const searchBy = [
    {
      label: 'eID',
      value: 'esimId',
    },
  ];
  return searchBy;
};

export const handleFetchCardLicense = async (filter, limit) => {
  try {
    const cardLicense = await fetchEsims({ filter, limit });
    return formatCardLicenses(cardLicense);
  } catch (error) {
    return [];
  }
};
